export default __webpack_public_path__ + "static/media/myclassroom-logo.ad9ecab9.svg";